import { yupResolver } from "@hookform/resolvers/yup";
import {
  Box,
  Button,
  Grid,
  Typography,
  useMediaQuery
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import authApi from "api/authApi";
import { useAppDispatch, useAppSelector } from "app/hooks";
import InputField from "components/FormFields/InputField";
import { SelectField } from "components/FormFields/SelectFiled";
import {
  fetchDataOptions,
  selectListClass
} from "features/Auth/options/optionsSlice";
import { UserRegister } from "models/auth";
import { ResponseStatus } from "models/common";
import { IClass } from "models/managerClass";
import moment from "moment";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import * as yup from "yup";
import useStyles from "./style";

const schema = yup.object().shape({
  email: yup.string().email("*Vui lòng nhập đúng định dạng email"),
  staffId: yup.string().required("*Mã nhân viên bắt buộc nhập ."),
  phone: yup.string().required("*Số điện thoại bắt buộc nhập ."),
  name: yup.string().required("*Họ và tên bắt buộc nhập."),
  classId: yup.string().required("*Lớp học bắt buộc chọn"),
});

export default function CreateStudent({ handleClose }: any) {
  const { t } = useTranslation();

  const listClass = useAppSelector(selectListClass);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down("sm"));

  useEffect(() => {
    dispatch(fetchDataOptions());
  }, [dispatch]);

  const initialValues: UserRegister = {
    email: "",
    staffId: "",
    name: "",
    areaId: "",
    phone: "",
    provinceId: "",
    dateOfJoining: "",
    workTypeId: "",
    position: "",
    farmId: "",
    departmentId: "",
    newProvinceId: "",
    classId: "",
  };

  const { control, handleSubmit, formState: { isSubmitting } } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const handleSubmitForm = async (infoUser: UserRegister) => {
    try {
      const res: ResponseStatus = await authApi.register({
        ...infoUser,
        areaId: 3,
        departmentId: 2,
        newProvinceId: 45,
        position: "Nhân viên",
        dateOfJoining: moment(new Date()).format("YYYY-MM-DD"),
        classId: Number(infoUser.classId),
        password: "gpet123",
        confirmPassword: "gpet123",
      });
      if (res.responseCode === "00") {
        handleClose();
        toast.success(t("auth.registerSuccess"));
      } else if (res.responseCode === "02") {
        toast.error(t("auth.emalOrStaffIdExisted"));
      } else if (res.responseCode === "01") {
        toast.error(t("auth.missingField"));
      } else {
        toast.error(res.responseDescription);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <form onSubmit={handleSubmit(handleSubmitForm)}>
          <Grid container spacing={2} className={classes.form__content}>
            <Grid item xs={12}>
              <InputField
                name="name"
                label={t("auth.fullName") + " *"}
                control={control}
                borderRadius="12px"
                required={true}
                autocomplete={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputField
                name="staffId"
                label={t("auth.code") + " *"}
                control={control}
                borderRadius="12px"
                required={true}
                autocomplete={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputField
                name="email"
                label={t("auth.email") + " *"}
                control={control}
                borderRadius="12px"
                required={true}
                autocomplete={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <InputField
                name="phone"
                label={t("auth.phone") + " *"}
                control={control}
                borderRadius="12px"
                type="number"
                autocomplete={true}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <SelectField
                name="classId"
                label={t("auth.class")}
                options={listClass.map((item: IClass) => ({
                  id: item.id,
                  name: item.name,
                }))}
                control={control}
                borderRadius="12px"
                required
              />
            </Grid>
          </Grid>

          <Box className={classes.noticeCard}>
            <LockOutlinedIcon style={{ color: "#D97706", fontSize: 20, flexShrink: 0 }} />
            <Typography className={classes.noticeText}>
              Mật khẩu khởi tạo mặc định cho học viên là: <strong>gpet123</strong>
            </Typography>
          </Box>

          <Box className={classes.actionGroup}>
            <Button
              variant="outlined"
              className={classes.btnCancel}
              onClick={handleClose}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={classes.btnSubmit}
              disabled={isSubmitting}
            >
              {t("auth.register")}
            </Button>
          </Box>
        </form>
      </Box>
    </Box>
  );
}
